import api from '.'

export const participantEvents = {
  create (trialId, participantId, data, success, fail) {
    api.authenticatedRequest(
      'POST',
      `/trials/${trialId}/participants/${participantId}/events`,
      data,
      success,
      fail
    )
  },
  listForParticipant (trialId, participantId, success, fail) {
    api.authenticatedRequest(
      'GET',
      `/trials/${trialId}/participants/${participantId}/events`,
      null,
      success,
      fail
    )
  },
  update (trialId, participantId, eventId, data, success, fail) {
    api.authenticatedRequest(
      'PUT',
      `/trials/${trialId}/participants/${participantId}/events/${eventId}`,
      data,
      success,
      fail
    )
  },
  delete (trialId, participantId, eventId, success, fail) {
    api.authenticatedRequest(
      'DELETE',
      `/trials/${trialId}/participants/${participantId}/events/${eventId}`,
      null,
      success,
      fail
    )
  }
}
